/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import SystemApiClient from "../Api/SystemApiClient";

interface LoginCredential {
    eMail: string;
    password: string;
    mandantKennung?: string;
}

export default class AuthenticationClient extends SystemApiClient {
    public constructor() {
        super("auth");
    }

    public login(eMail: string, password: string, mandantKennung?: string, captchaToken?: string): Promise<Response> {
        const credential: LoginCredential = { eMail, password, mandantKennung };
        const headers = { "captcha-token": captchaToken ?? "" }
        return this.post("login", credential, headers);
    }

    public logout(): Promise<Response> {
        return this.post("logout");
    }

    public async ermittleRelativeErsteMandantUrl(): Promise<string | undefined> {
        const response = await this.get("ermittleRelativeErsteMandantUrl");
        const responseText = await response.text();
        return responseText ? JSON.parse(responseText) : undefined;
    }

    public async istMandantGueltig(mandantKennung: string): Promise<boolean> {
        const response = await this.post("istMandantGueltig", mandantKennung);
        return await response.text() === "true";
    }

    // ACHTUNG: Diese Methode darf nur aufgerufen werden, um Support-Konten einen befristeten Zugang zu
    // einem Mandanten zu gewähren!
    public async gewaehreZugriffaufMandant(kennung: string): Promise<Response> {
        return await this.post("accessgrant", kennung);
    }

    public async refreshToken(): Promise<Response> {
        return await this.post("RefreshToken");
    }
}
